import { render, staticRenderFns } from "./PracticePage.vue?vue&type=template&id=ab5f7e86&scoped=true&"
import script from "./PracticePage.vue?vue&type=script&lang=js&"
export * from "./PracticePage.vue?vue&type=script&lang=js&"
import style0 from "./PracticePage.vue?vue&type=style&index=0&id=ab5f7e86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5f7e86",
  null
  
)

export default component.exports